/**
 * Simple Event Bus for Vue 3 compatibility
 * Replaces the deprecated this.$root.$on / this.$root.$emit pattern
 */

type EventCallback = (...args: any[]) => void

class EventBus {
  private events: Map<string, Set<EventCallback>> = new Map()

  /**
   * Subscribe to an event
   */
  on(event: string, callback: EventCallback): void {
    if (!this.events.has(event)) {
      this.events.set(event, new Set())
    }
    this.events.get(event)!.add(callback)
  }

  /**
   * Unsubscribe from an event
   */
  off(event: string, callback: EventCallback): void {
    if (this.events.has(event)) {
      this.events.get(event)!.delete(callback)
    }
  }

  /**
   * Emit an event with optional arguments
   */
  emit(event: string, ...args: any[]): void {
    if (this.events.has(event)) {
      this.events.get(event)!.forEach(callback => {
        callback(...args)
      })
    }
  }
}

// Singleton instance
export const eventBus = new EventBus()

// Event names constants
export const EVENTS = {
  QUESTION_CREATED: 'questionCreated'
} as const
